// Russian translations
const ru = {
  // Placeholder structure to prevent errors
  navigation: {
    tracking: "Отслеживание",
    search: "Поиск",
    login: "мойMSC",
    language: "Язык"
  },
  
  menu: {
    solutions: "Решения",
    industries: "Отрасли",
    ebusiness: "Электронный бизнес",
    sustainability: "Устойчивое развитие",
    aboutUs: "О Нас",
    schedules: "Расписания"
  },
  
  hero: {
    leaderIn: "ЛИДЕР В",
    shippingLogistics: "СУДОХОДСТВЕ И ЛОГИСТИКЕ",
    trackingTab: "ОТСЛЕЖИВАНИЕ",
    schedulesTab: "РАСПИСАНИЯ",
    contactsTab: "КОНТАКТЫ",
    containerBol: "Номер контейнера / коносамента",
    bookingNumber: "Номер бронирования",
    searchPlaceholder: "Поиск наших услуг и решений...",
    searchButton: "Поиск"
  },
  
  // Default fallback for other sections
  example: {},
  services: {},
  stats: {
    title: "Глобальный охват, локальная экспертиза",
    description: "С обширной глобальной сетью и глубокими локальными знаниями мы соединяем бизнес по всем континентам.",
    years: "Лет опыта",
    countries: "Стран обслуживания",
    clients: "Активных клиентов",
    shipments: "Годовых отправлений"
  },
  industries: {},
  footer: {}
};

export default ru; 